const LoanDisbursementActionTypes = {
	/** ***************** GET LOAN DISBURSEMENT START *********************** */
	GET_LOAN_DISBURSEMENT_LIST_START: 'get_loan_disbursement_list_start',
	GET_LOAN_DISBURSEMENT_LIST_SUCCESS: 'get_loan_disbursement_list_success',
	GET_LOAN_DISBURSEMENT_LIST_FAILURE: 'get_loan_disbursement_list_failure',
	GET_LOAN_DISBURSEMENT_LIST_RESPONSE_RESET: 'get_loan_disbursement_list_response_reset',
	GET_LOAN_DISBURSEMENT_LIST_RESPONSE_CHANGED: 'get_loan_disbursement_list_response_changed',
	/** ***************** GET LOAN DISBURSEMENT END *********************** */

	/** ***************** GET OFFICER BASED ON BRANCH DETAILS START *********************** */
	GET_OFFICER_BRANCH_LIST_START: 'get_officer_branch_start',
	GET_OFFICER_BRANCH_LIST_SUCCESS: 'get_officer_branch_success',
	GET_OFFICER_BRANCH_LIST_FAILURE: 'get_officer_branch_failure',
	GET_OFFICER_BRANCH_LIST_RESPONSE_RESET: 'get_officer_branch_response_reset',
	GET_OFFICER_BRANCH_LIST_RESPONSE_CHANGED: 'get_officer_branch_response_changed',
	/** ***************** GET OFFICER BASED ON BRANCH DETAILS END *********************** */

	/** ***************** FETCH ALL PRODUCT TYPE START *********************** */
	FETCH_ALL_ECONOMIC_ACTIVITY_START: 'fetch_all_economic_activity_start',
	FETCH_ALL_ECONOMIC_ACTIVITY_SUCCESS: 'fetch_all_economic_activity_success',
	FETCH_ALL_ECONOMIC_ACTIVITY_FAILURE: 'fetch_all_economic_activity_failure',
	FETCH_ALL_ECONOMIC_ACTIVITY_RESPONSE_RESET: 'fetch_all_economic_activity_response_reset',
	FETCH_ALL_ECONOMIC_ACTIVITY_RESPONSE_CHANGED: 'fetch_all_economic_activity_response_changed',
	/** ***************** FETCH ALL PRODUCT TYPE END *********************** */
};
export default LoanDisbursementActionTypes;
